import React from 'react';
import { BulkUploader } from 'cccisd-laravel-nexus';

const BulkAddCaregiverForm = ({ loadData }) => (
    <BulkUploader
        handle="supervisorBulkCaregiver"
        trigger={
            <button type="button" className="btn btn-primary">
                Bulk Add Caregivers
            </button>
        }
        loadData={loadData}
    />
);

export default BulkAddCaregiverForm;
